<p-dialog
  header="Copy Package"
  [visible]="visible()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '48rem', maxWidth: '95vw' }"
  appendTo="body"
  (visibleChange)="close()"
>
  <div class="flex flex-col gap-4">
    <div class="grid sm:grid-cols-2 gap-4">
      <div class="flex flex-col gap-1.5">
        <label class="text-sm text-slate-600">Package Name</label>
        <input pInputText type="text" class="w-full" [ngModel]="sourcePackage().name" [disabled]="true" />
      </div>

      <div class="flex flex-col gap-1.5">
        <label class="text-sm text-slate-600">Project</label>
        <generic-dropdown
          [clearable]="false"
          [allowSearch]="false"
          [disabled]="true"
          [items]="projectSelectOptions()"
          [ngModel]="'project'"
        />
      </div>

      <div class="flex flex-col gap-1.5">
        <label class="text-sm text-slate-600">Model(Elevation)</label>
        <generic-dropdown
          [clearable]="false"
          [allowSearch]="false"
          [disabled]="true"
          [items]="modelElevationSelectOptions()"
          [ngModel]="'modelElevation'"
        />
      </div>

      <div class="flex flex-col gap-1.5">
        <label class="text-sm text-slate-600">Discount Percentage</label>
        <input pInputText type="text" class="w-full" [ngModel]="discountPercentage() + '%'" [disabled]="true" />
      </div>
    </div>

    @if (optionRows().length > 0) {
      <div class="flex flex-col gap-1.5">
        <label class="text-sm text-slate-600">Options</label>
        <div class="max-h-52 overflow-y-auto rounded-lg border border-solid border-slate-200">
          <p-table [value]="optionRows()" styleClass="p-datatable-sm">
            <ng-template #header>
              <tr>
                <th>Description</th>
                <th>Unit Price</th>
                <th>Category / Subcategory</th>
                <th>Type</th>
                <th>UoM</th>
                <th class="text-center">Quantity</th>
              </tr>
            </ng-template>
            <ng-template #body let-row>
              <tr>
                <td>{{ row.description || '—' }}{{ row.code ? ' (' + row.code + ')' : '' }}</td>
                <td>
                  @if (discountPercentage()) {
                    <span class="text-surface-400 line-through">{{ row.unitPrice | currencyFormat }}</span>
                    <span class="ml-1">{{ row.discountedUnitPrice | currencyFormat }}</span>
                  } @else {
                    {{ row.unitPrice | currencyFormat }}
                  }
                </td>
                <td>{{ row.category || '—' }} / {{ row.subcategory || '—' }}</td>
                <td>
                  @if (row.type) {
                    <p-tag [value]="row.type" size="small" severity="success" />
                  } @else {
                    —
                  }
                </td>
                <td>{{ row.uom || '—' }}</td>
                <td class="text-center">{{ row.count }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    }

    <div class="flex flex-col gap-2">
      <div class="flex items-baseline justify-between gap-3">
        <label class="text-sm text-slate-600">Apply To</label>
        <span class="text-xs text-slate-500">
          @if (isCheckingTargets()) {
            Checking targets…
          } @else {
            {{ selectedCount() }} selected
          }
        </span>
      </div>

      <div class="flex items-center gap-3.5">
        <button
          type="button"
          class="appearance-none bg-transparent border-0 p-0 m-0 flex items-center gap-2 shrink-0 cursor-pointer disabled:cursor-not-allowed"
          [disabled]="selectAllDisabled()"
          (click)="toggleSelectAll()"
        >
          <span
            class="flex items-center justify-center w-4 h-4 rounded border border-solid shrink-0"
            [class.border-primary-500]="allSelected()"
            [class.bg-primary-500]="allSelected()"
            [class.text-white]="allSelected()"
            [class.border-slate-300]="!allSelected()"
            [class.bg-white]="!allSelected()"
          >
            @if (allSelected()) {
              <i class="pi pi-check text-[9px]"></i>
            }
          </span>
          <span class="text-sm font-medium text-slate-900 whitespace-nowrap">Select all</span>
        </button>

        <p-iconfield class="flex-1">
          <p-inputicon styleClass="pi pi-search" />
          <input
            pInputText
            type="text"
            class="w-full"
            placeholder="Search models or elevations"
            [ngModel]="searchTerm()"
            (ngModelChange)="searchTerm.set($event)"
          />
        </p-iconfield>
      </div>

      @if (isLoadingTargets()) {
        <div class="text-sm text-slate-500 text-center py-6">Loading models…</div>
      } @else if (targetsLoadFailed()) {
        <div class="flex flex-col items-center gap-2 py-6">
          <span class="text-sm text-red-600">Could not load models for this project.</span>
          <p-button label="Retry" size="small" [text]="true" (onClick)="retryTargets()" />
        </div>
      } @else if (noModelsInProject()) {
        <div class="text-sm text-slate-500 text-center py-6">No models or elevations found for this project.</div>
      } @else if (noSearchMatches()) {
        <div class="text-sm text-slate-500 text-center py-6">No models or elevations match "{{ searchTerm() }}".</div>
      } @else {
        <div class="flex flex-col gap-2 max-h-72 overflow-y-auto p-0.5">
          @for (model of models(); track model.modelId) {
            <div class="rounded-lg border border-solid overflow-hidden shrink-0 border-slate-200">
              <div class="flex items-center gap-3 px-3.5 py-3 cursor-pointer bg-white" (click)="toggleExpand(model)">
                <button
                  type="button"
                  class="appearance-none p-0 m-0 flex items-center justify-center w-4 h-4 rounded border border-solid shrink-0 cursor-pointer disabled:cursor-not-allowed"
                  [class.border-primary-500]="model.allSelected"
                  [class.bg-primary-500]="model.allSelected"
                  [class.text-white]="model.allSelected"
                  [class.border-slate-300]="!model.allSelected && model.selectableCount > 0"
                  [class.bg-white]="!model.allSelected && model.selectableCount > 0"
                  [class.border-slate-200]="model.selectableCount === 0"
                  [class.bg-slate-100]="model.selectableCount === 0"
                  [disabled]="model.selectableCount === 0"
                  (click)="$event.stopPropagation(); toggleModel(model)"
                >
                  @if (model.allSelected) {
                    <i class="pi pi-check text-[9px]"></i>
                  }
                </button>

                <span class="flex-1 min-w-0 text-sm font-semibold truncate text-slate-900">{{ model.modelName }}</span>

                <span class="shrink-0 text-xs text-slate-400">
                  {{
                    model.selectedCount
                      ? model.selectedCount + ' of ' + model.elevations.length + ' selected'
                      : model.elevations.length + ' elevations'
                  }}
                </span>

                <span class="shrink-0 w-6 h-6 rounded-full bg-slate-100 flex items-center justify-center">
                  <i
                    class="pi text-[10px] text-slate-500"
                    [class.pi-chevron-down]="model.expanded"
                    [class.pi-chevron-right]="!model.expanded"
                  ></i>
                </span>
              </div>

              @if (model.expanded) {
                <div class="border-0 border-t border-solid border-slate-100 py-1.5 px-2">
                  @for (elevation of model.visibleElevations; track elevation.elevationId) {
                    <div
                      class="flex items-center gap-3 pl-9 pr-2.5 py-2 rounded-md"
                      [class.opacity-60]="!elevation.selectable"
                      [class.cursor-not-allowed]="!elevation.selectable"
                      [class.bg-primary-50]="
                        elevation.selected && elevation.state !== 'refused' && elevation.state !== 'failed'
                      "
                      [class.bg-red-50]="elevation.state === 'refused' || elevation.state === 'failed'"
                      [class.bg-amber-50]="elevation.state === 'partial'"
                    >
                      <button
                        type="button"
                        class="appearance-none p-0 m-0 flex items-center justify-center w-4 h-4 rounded border border-solid shrink-0 cursor-pointer disabled:cursor-not-allowed"
                        [class.border-primary-500]="elevation.selected"
                        [class.bg-primary-500]="elevation.selected"
                        [class.text-white]="elevation.selected"
                        [class.border-slate-300]="!elevation.selected && elevation.selectable"
                        [class.bg-white]="!elevation.selected && elevation.selectable"
                        [class.border-slate-200]="!elevation.selectable"
                        [class.bg-slate-100]="!elevation.selectable"
                        [disabled]="!elevation.selectable"
                        (click)="toggleElevation(elevation)"
                      >
                        @if (elevation.selected) {
                          <i class="pi pi-check text-[9px]"></i>
                        }
                      </button>

                      <span class="shrink-0 text-sm text-slate-700">{{ elevation.label }}</span>

                      @if (elevation.state === 'checking') {
                        <i class="pi pi-spin pi-spinner text-xs text-slate-400"></i>
                      }

                      @if (elevation.reason) {
                        <span
                          class="flex-1 min-w-0 text-xs text-right truncate"
                          [class.text-slate-500]="
                            !elevation.state || elevation.state === 'checking' || elevation.state === 'ok'
                          "
                          [class.text-red-600]="elevation.state === 'refused' || elevation.state === 'failed'"
                          [class.text-amber-600]="elevation.state === 'partial'"
                          [title]="elevation.missingOptionsTooltip"
                        >
                          {{ elevation.reason }}
                        </span>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }

      @if (previewFailed()) {
        <div class="flex items-center justify-between gap-3 text-xs text-red-600">
          <span>Could not check which targets are eligible.</span>
          <p-button label="Retry" size="small" [text]="true" (onClick)="retryPreview()" />
        </div>
      }

      @if (copyError()) {
        <div class="text-sm text-red-600">{{ copyError() }}</div>
      }

      @if (outcomes(); as results) {
        <div class="flex flex-col gap-1 rounded-lg border border-solid border-slate-200 p-3">
          @for (result of results; track result.label) {
            <div class="flex items-center justify-between gap-3 text-xs">
              <span
                [class.text-slate-700]="result.status === 'created'"
                [class.text-red-600]="result.status !== 'created'"
              >
                {{ result.label }} —
                {{ result.status === 'created' ? 'Copied' : result.status === 'refused' ? 'Refused' : 'Skipped' }}
              </span>
              @if (result.status !== 'created' && result.reason) {
                <span class="text-slate-500 text-right truncate">{{ result.reason }}</span>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>

  <ng-template #footer>
    <div class="flex items-center justify-end gap-2">
      <p-button label="Cancel" severity="secondary" [text]="true" (onClick)="close()" />
      <p-button
        [label]="copyButtonLabel()"
        icon="pi pi-copy"
        [loading]="isCopying()"
        [disabled]="!canCopy()"
        (onClick)="copy()"
      />
    </div>
  </ng-template>
</p-dialog>
